"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _components = require("components");

var _glamor = require("glamor");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _utils = require("utils");

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bridge = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loggedIn: state.auth.loggedIn,
    user: state.user,
    eolConfig: state.eol.eolConfig
  };
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(Bridge, _React$Component);

  function Bridge(props) {
    (0, _classCallCheck3.default)(this, Bridge);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Bridge.__proto__ || (0, _getPrototypeOf2.default)(Bridge)).call(this, props));

    _this.state = {
      platform: "Windows"
    };
    return _this;
  }

  (0, _createClass3.default)(Bridge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({ platform: platform });
    }
  }, {
    key: "render",
    value: function render() {
      var platform = this.state.platform;
      var _props = this.props,
          user = _props.user,
          eolConfig = _props.eolConfig;

      var fabInLauncherUrl = eolConfig && eolConfig.common && eolConfig.common.fabInLauncherURL ? eolConfig.common.fabInLauncherURL : "com.epicgames.launcher://fab";

      var bridgeDownloadUrl = _utils.bridgeBuilds[platform.toLowerCase()];
      var mailTo = encodeURI("mailto:?subject=Quixel Bridge Download Link&body=Note to self: Remember to download Quixel Bridge the next time I am on my desktop machine.\n" + "Here are the download links —\n\n" + "Windows: " + _utils.bridgeBuilds.windows + "\n\n" + "Mac: " + _utils.bridgeBuilds.mac + "\n\n" + "Linux: " + _utils.bridgeBuilds.linux + "\n\n");

      if (__CLIENT__ && (0, _utils.detectMobileAndTablet)()) {
        bridgeDownloadUrl = mailTo;
      }

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "Bridge - Manage 3D content and export with one click",
          documentImage: cf_utils.cf_thumbs("shareimage-br.jpg"),
          documentDescription: "Quixel Bridge provides 3D asset management and saves time with one click integrations to your preferred tools, for free." },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_components.Hero, {
            bg: cf_utils.cf_qx_page("bridge", "Bridge_First_Frame.jpeg"),
            backgroundVideo: {
              poster: cf_utils.cf_qx_page("bridge", "Bridge_First_Frame.jpeg"),
              loop: "true",
              src: cf_utils.cf_qx_page("bridge", "Bridge-Website-Aspen.mp4")
            },
            superIconUrls: [cf_utils.cf_icons("bridge_icon_2048.png")],
            primaryLabel: "",
            primaryTo: "",
            title: "Bridge",
            opacity: 0.25,
            subTitle: "ACCESS YOUR LEGACY MEGASCANS AND METAHUMANS",
            secondaryLabel: "Download legacy Bridge",
            secondaryTo: bridgeDownloadUrl,
            onClickSecondaryHandler: function onClickSecondaryHandler() {
              if (window && _epicTracking) {
                window.trackEpicIntrection({
                  eventCategory: "Software",
                  eventAction: "Download",
                  eventLabel: "Bridge",
                  interactionType: "click",
                  eventValue: 100
                });
              }
            },
            linkIcon: "rightSide",
            artist: "RENDERED IN UNREAL ENGINE 5"
          }),
          _react2.default.createElement(_components.Feature, {
            flip: true,
            featureType: "Fab in Launcher",
            images: [cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-1.jpg"), cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-2.jpg"), cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-3.jpg"), cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-4.jpg"), cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-5.jpg")],
            title: "How do I access Megascans?",
            newHome: true,
            desc: _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "p",
                null,
                "Bridge was formerly your main gateway to Megascans. Today, Megascans are available on Fab, Epic\u2019s open online marketplace, and you can access the entire library of free and for-purchase content directly in the Epic Games Launcher. Quickly transfer Megascans individually or in batches from Fab in Launcher directly into leading digital content creation tools, including Unity, Blender, Maya, 3ds Max, Cinema 4D, and of course, Unreal Engine, in a range of standardized formats."
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "p",
                { className: _fonts.p3 },
                "Don\u2019t have the Epic Games Launcher yet?",
                " ",
                _react2.default.createElement(_components.TextButtonLibrary, {
                  className: _fonts.p3,
                  mode: "normal-small",
                  href: (0, _utils.getLauncherBuild)(),
                  label: "Download it here."
                })
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(_components.TextButtonLibrary, {
                  className: (0, _glamor.css)({ padding: 0 }, _fonts.p3),
                  mode: "normal-small",
                  href: fabInLauncherUrl,
                  label: "See Fab in the Epic Games Launcher"
                })
              )
            )
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "Bridge",
            img: cf_utils.cf_qx_page("megascans", "2_Surfaces.jpg"),
            title: "Is Bridge still available?",
            newHome: true,
            desc: _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "p",
                null,
                "Yes! While Megascans have received a significant technical and visual update as part of their move to Fab, if you have legacy Megascans previously acquired from Quixel.com or Bridge, you can still access them through Bridge, which is available on Windows, macOS, and Linux. Custom licensees may also choose to continue to use Bridge as part of their specific pipeline and studio requirements."
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(_components.TextButtonLibrary, {
                  className: (0, _glamor.css)({ padding: 0 }, _fonts.p3),
                  mode: "normal-small",
                  href: bridgeDownloadUrl,
                  label: "Download Bridge"
                })
              )
            )
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "BRIDGE",
            newHome: true,
            img: cf_utils.cf_qx_page("bridge", "connect_with_any_software_UE5.jpeg"),
            title: "Connect with any software",
            desc: "Send assets straight to Unreal Engine, 3ds Max, Houdini, Unity, Blender, Cinema 4D, Clarisse, Maya, and more, with automatic mesh and shader setups for all major renderers. Forget trying to correctly set up shaders or spending time hooking up map slots\u2014just jump right into your project.",
            link: [{
              href: "https://www.youtube.com/quixeltools",
              label: "Watch tutorials",
              newWindow: true
            }],
            flip: true
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "BRIDGE",
            newHome: true,
            img: cf_utils.cf_qx_page("bridge", "choose_the_right_format_for_you_UE5.jpeg"),
            title: "Choose the right format for you",
            desc: "Work in the format you want. Bridge offers a variety of formats: from the standard FBX to up-and-coming standards such as USD and MDL. Whatever you choose, we\u2019ve got you covered.",
            link: [{
              href: bridgeDownloadUrl,
              label: __CLIENT__ && (0, _utils.detectMobileAndTablet)() ? "Download" : ("Download for " + this.state.platform).toUpperCase(),
              newWindow: true,
              onClick: function onClick() {
                if (window && _epicTracking) {
                  window.trackEpicIntrection({
                    eventCategory: "Software",
                    eventAction: "Download",
                    eventLabel: "Bridge",
                    interactionType: "click",
                    eventValue: 100
                  });
                }
              }
            }]
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "BRIDGE",
            newHome: true,
            img: cf_utils.cf_qx_page("bridge", "bridge-avaliable-on-pc-mac-and-linux.jpg"),
            title: "Available on PC, Linux and Mac",
            desc: "Quixel Bridge is available for Windows, Linux and macOS.",
            link: [{
              href: bridgeDownloadUrl,
              label: __CLIENT__ && (0, _utils.detectMobileAndTablet)() ? "Download" : ("Download for " + this.state.platform).toUpperCase(),
              newWindow: true,
              onClick: function onClick() {
                if (window && _epicTracking) {
                  window.trackEpicIntrection({
                    eventCategory: "Software",
                    eventAction: "Download",
                    eventLabel: "Bridge",
                    interactionType: "click",
                    eventValue: 100
                  });
                }
              }
            }],
            artist: "Sergey Ferley",
            flip: true
          })
        )
      );
    }
  }]);
  return Bridge;
}(_react2.default.Component)) || _class);
exports.default = Bridge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Apps/Bridge.jsx
// module id = 2882
// module chunks = 0